import * as React from 'react';
import {PropsWithChildren} from 'react';
import * as ReactDOM from 'react-dom';
import {classNames} from '../Support/classNames';

interface OwnProps {
    visible: boolean;
    forced?: boolean;
    wide?: boolean;
    fluid?: boolean;
    onHide: () => any;
    onShow?: () => any;
}

export default class Modal extends React.Component<PropsWithChildren<OwnProps>> {
    public componentDidMount() {
        document.addEventListener('keydown', this.escapeListener);
    }

    private escapeListener = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            this.props.onHide();
        }
    };

    public componentWillUnmount() {
        //Remove `esc` key listener
        document.removeEventListener('keydown', this.escapeListener);
    }

    public render() {
        const mountingPoint = document.getElementById('modal');
        if (mountingPoint === null) {
            return null;
        }

        return ReactDOM.createPortal(
            <div className={classNames('modal', 'fade', {show: this.props.visible})}>
                <div
                    className={classNames('modal-dialog', {
                        'modal-lg': this.props.wide,
                        'modal-fluid': this.props.fluid,
                    })}
                >
                    <div className="modal-content">{this.props.visible ? this.props.children : null}</div>
                </div>
            </div>,
            mountingPoint,
        );
    }
}
